(function () {
  window.KROWN = window.KROWN || {};
  window.KROWN.variantGlobalIds = window.KROWN.variantGlobalIds || {};

  const variantGlobalIdFetchCache = new Map();

  const mergeVariantGlobalIdsFromDom = () => {
    document.querySelectorAll('script[type="application/json"][data-variant-global-ids]').forEach((el) => {
      try {
        const chunk = JSON.parse(el.textContent.trim());
        if (chunk && typeof chunk === 'object' && !Array.isArray(chunk)) {
          Object.assign(window.KROWN.variantGlobalIds, chunk);
        }
      } catch (_e) {
        /* ignore invalid JSON */
      }
    });
  };

  window.initVariantGlobalIdsFromDom = mergeVariantGlobalIdsFromDom;

  const extractGlobalId = (v) => {
    if (v == null) return '';
    if (typeof v === 'object' && !Array.isArray(v)) return v.globalId == null ? '' : String(v.globalId);
    return String(v);
  };

  window.getVariantGlobalIdForCart = (variantId) => {
    mergeVariantGlobalIdsFromDom();
    const map = window.KROWN.variantGlobalIds || {};
    const key = String(variantId);
    if (Object.prototype.hasOwnProperty.call(map, key)) return extractGlobalId(map[key]);
    if (Object.prototype.hasOwnProperty.call(map, variantId)) return extractGlobalId(map[variantId]);
    return '';
  };

  const getExistingLineGlobalId = (properties) =>
    String(properties?._globalId ?? properties?._globalid ?? '').trim();

  window.mergeCartLinePropertiesWithGlobalId = (variantId, properties) => {
    const base =
      properties && typeof properties === 'object' && !Array.isArray(properties)
        ? { ...properties }
        : {};
    const resolved = String(window.getVariantGlobalIdForCart(variantId) || '').trim();
    base._globalId = resolved || getExistingLineGlobalId(base);
    return base;
  };

  window.applyVariantGlobalIdToCartItemsSync = (items) => {
    if (!Array.isArray(items)) {
      return;
    }
    mergeVariantGlobalIdsFromDom();
    for (const it of items) {
      const vid = it.variant_id ?? it.id;
      if (vid == null) {
        continue;
      }
      it.properties = window.mergeCartLinePropertiesWithGlobalId(vid, it.properties);
    }
  };

  window.fetchVariantGlobalIdsForProductHandle = async (handle) => {
    if (!handle) {
      return {};
    }
    if (variantGlobalIdFetchCache.has(handle)) {
      const cached = variantGlobalIdFetchCache.get(handle);
      Object.assign(window.KROWN.variantGlobalIds, cached);
      return cached;
    }
    try {
      const url = `/products/${encodeURIComponent(handle)}?view=variant-global-ids`;
      const res = await fetch(url);
      if (!res.ok) {
        variantGlobalIdFetchCache.set(handle, {});
        return {};
      }
      const parsed = JSON.parse((await res.text()).trim());
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        Object.assign(window.KROWN.variantGlobalIds, parsed);
        variantGlobalIdFetchCache.set(handle, parsed);
        return parsed;
      }
    } catch (_e) {
      /* ignore */
    }
    variantGlobalIdFetchCache.set(handle, {});
    return {};
  };

  window.applyVariantGlobalIdToCartItemsWithHandles = async (items) => {
    if (!Array.isArray(items)) {
      return;
    }
    const handles = [...new Set(items.map((i) => i.handle).filter(Boolean))];
    await Promise.all(handles.map((h) => window.fetchVariantGlobalIdsForProductHandle(h)));
    window.applyVariantGlobalIdToCartItemsSync(items);
  };

  window.prepareCartAddBodyWithVariantGlobalIds = async (body, headers) => {
    mergeVariantGlobalIdsFromDom();
    if (body == null) {
      return body;
    }
    const ct = headers && headers['Content-Type'];
    if (typeof body !== 'string') {
      return body;
    }
    if (ct && ct.includes('application/json')) {
      try {
        const data = JSON.parse(body);
        if (Array.isArray(data.items)) {
          const hasHandles = data.items.some((i) => i.handle);
          if (hasHandles) {
            await window.applyVariantGlobalIdToCartItemsWithHandles(data.items);
          } else {
            window.applyVariantGlobalIdToCartItemsSync(data.items);
          }
        }
        return JSON.stringify(data);
      } catch (_e) {
        return body;
      }
    }
    if (ct && ct.includes('application/x-www-form-urlencoded')) {
      const params = new URLSearchParams(body);
      const id = params.get('id');
      if (id) {
        const resolved = String(window.getVariantGlobalIdForCart(id) || '').trim();
        const existing = String(params.get('properties[_globalId]') || '').trim();
        params.set('properties[_globalId]', resolved || existing);
        return params.toString();
      }
    }
    return body;
  };

  mergeVariantGlobalIdsFromDom();
})();
